import { render, staticRenderFns } from "./general_info_form.vue?vue&type=template&id=b34a7e52&scoped=true&"
import script from "./general_info_form.vue?vue&type=script&lang=js&"
export * from "./general_info_form.vue?vue&type=script&lang=js&"
import style0 from "./general_info_form.vue?vue&type=style&index=0&id=b34a7e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34a7e52",
  null
  
)

export default component.exports